import { deepmerge } from '../utils'
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import './style.css'
import appState from '../../store/app'
const vuetify = appState.$vuetify

function toast ({type, title, message, ...args}) {
  const { emergency = false } = args
  const defaultOptions = {
    timeout: 10000,
    position: vuetify.breakpoint.smAndUp ? 'topRight' : 'bottomCenter'
  }
  if (emergency) {
    const emergencyOptions = {
      theme: 'dark',
      position: 'center',
      iconColor: 'rgba(255, 255, 255, 0.5)',
      messageColor: 'rgba(255, 255, 255, 0.9)',
      timeout: false,
      pauseOnHover: true,
      layout: 2,
      overlay: true,
      overlayClose: true,
      transitionIn: 'fadeInDown',
      transitionOut: 'fadeOutDown'
    }
    switch (type) {
      case 'success':
        emergencyOptions.color = '#00af66'
        // emergencyOptions.icon = 'icon-check'
        break
      case 'error':
        emergencyOptions.color = '#BD5B5B'
        // emergencyOptions.icon = 'icon-power_settings_new'
        break
      case 'info':
        emergencyOptions.color = '#3498db'
        // emergencyOptions.icon = 'icon-power_settings_new'
        break
      case 'warning':
        emergencyOptions.color = '#f39c12'
        // emergencyOptions.icon = 'icon-power_settings_new'
        break
    }
    args = deepmerge(emergencyOptions, args, {
      class: ['emergency', args.class || ''].join(' ').trim()
    })
  }
  args = deepmerge(defaultOptions, args)
  iziToast[type]({title, message, ...args})
  return iziToast
}

export default {
  success: ({title = 'Success', message = 'Your request has been processed', ...args} = {}) => toast({type: 'success', title, message, ...args}),
  error: ({title = 'Error', message = 'That\'s the error', ...args} = {}) => toast({type: 'error', title, message, ...args}),
  info: ({title = 'Info', message = 'Here is some info for you', ...args} = {}) => toast({type: 'info', title, message, ...args}),
  warn: ({title = 'Warning', message = 'That\'s the kind of warning', ...args} = {}) => toast({type: 'warning', title, message, ...args})
}
